import { Container } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from '@material-ui/core/styles';
import Toolbar from "@material-ui/core/Toolbar";
import MenuIcon from "@material-ui/icons/Menu";
import clsx from 'clsx';
import SidebarAdminLeft from 'components/common/SidebarAdminLeft';
import React from 'react';
import { useMediaQuery } from 'react-responsive';

// const drawerWidth = 240;
const drawerWidth = 0;

const useStyles = makeStyles((theme) => ({
  root: {
    // display: 'flex',
  },
  container: {
    width: '100%',
    padding: theme.spacing(3),
  },

  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
    marginTop: 30
  },
  content: {
    flexGrow: 1,

    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
    // marginRight: +drawerWidth,    {/* For sidebar right  */}
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    // marginLeft: 0,
    marginLeft: 238,
    // marginRight: 0,   {/* For sidebar right  */}
  },
  contentContainer: {
    width: '100%',
    // backgroundColor: 'red',
    // height: 300
  }
}));

export default function AdminLayout(props) {
  const [open, setOpen] = React.useState(true);
  // const [open1, setOpen1] = React.useState(true);
  const classes = useStyles();

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  useMediaQuery({ query: `(max-width: 959px)` }, undefined, (matches) => {
    (matches) ? handleDrawerClose() : handleDrawerOpen()
  });


  return (
    <div className={classes.root}>
      <CssBaseline />
      <Toolbar>
        <IconButton
          color="secondary"
          aria-label="menu"
          onClick={handleDrawerToggle}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>
      <SidebarAdminLeft open={open} onDrawerClose={handleDrawerClose} />


      <main
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}
      >
        {/* <HeaderAdmin open={open} onDrawerToggle={handleDrawerToggle} /> */}
        {/* <div className={classes.drawerHeader} /> */}
        <Container className={classes.container} maxWidth={false}>
          <div className={classes.contentContainer}>
            {props.children}
          </div>

          {/* <div className={classes.contentContainer}>test</div> */}
        </Container>

      </main>
      {/* <SidebarAdminRight open={open} onDrawerClose={handleDrawerClose} />   */}   {/* For sidebar right  */}
    </div>
  );
}
